import React, { useEffect } from 'react'
import connect from './connect'
import SpacingContainerBase from '../../components/layouts/SpacingContainerBase'
import Loader from '../../components/common/Loader'
import { Grid } from '@material-ui/core'
import NothingFoundCardList from '../../components/generics/Cards/NothingFoundCard/NothingFoundCardList'
import PaginationSmall from '../../components/common/Paginations/PaginationSmall'
import AdminEventList from './components/AdminEventList'
import Header from './components/Header'
import { emptyArray } from '../../utils/arrayUtils'

const AdminEventHistory = ({
  adminEvents,
  onInit,
  onChangePage,
  onChangeRowPerPage,
  authUser,
}) => {
  const { items, count, pending, pagination } = adminEvents

  useEffect(() => {
    onInit()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <SpacingContainerBase>
      <Header />
      {pending && <Loader open={pending} />}
      {!emptyArray(items) ? (
        <Grid container spacing={2} direction='column'>
          <Grid item xs zeroMinWidth>
            <AdminEventList items={items} />
          </Grid>

          <Grid item xs zeroMinWidth>
            <PaginationSmall
              page={pagination.page}
              perPage={pagination.perPage}
              count={count}
              onChangePage={onChangePage}
              onChangeRowPerPage={onChangeRowPerPage}
              pending={pending}
            />
          </Grid>
        </Grid>
      ) : (
        !pending &&
        emptyArray(items) && (
          <Grid item xs zeroMinWidth>
            <NothingFoundCardList />
          </Grid>
        )
      )}
    </SpacingContainerBase>
  )
}

export default connect(AdminEventHistory)
